import { Environment } from '../components/zero-account/enums';
import { Build } from '@stencil/core';

export const format = (appId: string): string => {
  return appId || '';
}

export class Logger {
  private readonly environment: Environment;
  constructor(environment: Environment) {
    this.environment = environment;
  }
  log = (...args) => {
    if (this.environment !== 'production' && Build.isDev) {
      console.clear()
      console.log(...args);
    }
  }
}
